const SIZES = [
  [1e12, "TB"],
  [1e9, "GB"],
  [1e6, "MB"],
  [1e3, "KB"],
] as const;

/** A size, as Health and Owner tools show one: "73.4 MB", or "980 bytes". */
export function formatBytes(bytes: number): string {
  for (const [scale, unit] of SIZES) {
    if (bytes >= scale) {
      return `${(bytes / scale).toFixed(1)} ${unit}`;
    }
  }
  return `${bytes.toLocaleString("en-US")} bytes`;
}
